import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';

function handleDownload(id) {
  window.open(`${configuration.apiURL}/api/files/arquivo/${id}`, '_blank');
}

export default function FormDetailPlanosTrabalhos({
  planosTrabalhos,
  tipo,
  isIntegradoOxy
}) {
  const items = planosTrabalhos || List();
  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  if (items.size === 0) {
    return <p className="text-muted">Nenhum Plano de Trabalho informado.</p>;
  }

  return (
    <>
      {items.map((item, index) => {
        const metas = item.get('metas', List());
        const documentos = item.get('documentos', List());
        return (
          <React.Fragment key={index}>
            <DisplayData border className="mb-xs">
              <DisplayDataRow>
                <DisplayDataItem
                  sm={4}
                  title="Previsão Início"
                  value={item.get('dataInicio')}
                  id={`dataInicio-${index}`}
                />
                <DisplayDataItem
                  sm={4}
                  title="Previsão Fim"
                  value={item.get('dataFim')}
                  id={`dataFim-${index}`}
                />
              </DisplayDataRow>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={12}
                  title="Metas"
                  value={
                    metas.size > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {metas.map((meta, i) => (
                          <li key={i}>{meta}</li>
                        ))}
                      </ul>
                    ) : (
                      'Nenhuma Meta informada.'
                    )
                  }
                  id={`metas-${index}`}
                />
              </DisplayDataRow>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={12}
                  title="Documentos"
                  value={
                    documentos.size > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {documentos.map((documento, i) => (
                          <li
                            key={documento.get('id') || i}
                            style={{ maxWidth: 400 }}
                          >
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                              }}
                            >
                              {documento.get('nome') || 'Arquivo sem título'}
                              <button
                                type="button"
                                title="Download"
                                onClick={() =>
                                  handleDownload(documento.get('id'))
                                }
                                style={{
                                  border: 'none',
                                  background: 'none',
                                  cursor: 'pointer',
                                  padding: 0,
                                  marginLeft: 8
                                }}
                              >
                                <i className="fa fa-download"></i>
                              </button>
                            </span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      'Nenhum documento informado.'
                    )
                  }
                  id={`documentos-${index}`}
                />
              </DisplayDataRow>
            </DisplayData>
            <hr className="mt-xs mb-xs" />
          </React.Fragment>
        );
      })}
    </>
  );
}

FormDetailPlanosTrabalhos.propTypes = {
  planosTrabalhos: PropTypes.object,
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool
};
